"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
/**
 *
 * @preferred
 */
var service_1 = require("../service");
var _ = require("lodash");
var Availability;
(function (Availability) {
    function getAvailabilityForProductSet(products, organizationUnitIDs, fastestPickupShopOnly, includeAvailabilityTexts, detailedShopInformation) {
        if (fastestPickupShopOnly === void 0) { fastestPickupShopOnly = false; }
        if (includeAvailabilityTexts === void 0) { includeAvailabilityTexts = false; }
        if (detailedShopInformation === void 0) { detailedShopInformation = false; }
        return new Promise(function (resolve, reject) {
            // Create our service instance
            //
            var service = new service_1.EVAService("GetAvailabilityIndication");
            // Build the request data
            // The base class will add things like SessionID so to keep typescript
            // happy we're using an 'any' type object here
            //
            var requestData = {
                Products: products,
                FastestPickupShopOnly: fastestPickupShopOnly,
                PickupOrganizationUnitIDs: organizationUnitIDs,
                DetailedShopInformation: detailedShopInformation,
                IncludeAvailabilityTexts: includeAvailabilityTexts
            };
            // Perform the call and capture the resulting promise
            //
            service.call(requestData)
                .then(function (result) {
                resolve(_.get(result, "response.Products") || []);
            })
                .catch(reject);
        });
    }
    Availability.getAvailabilityForProductSet = getAvailabilityForProductSet;
    function getStockAvailabilityEstimateForProducts(organizationUnitId, products) {
        return new Promise(function (resolve, reject) {
            var service = new service_1.EVAService("GetStockAvailabilityEstimateForProducts");
            var requestData = {
                OrganizationUnitID: organizationUnitId,
                Products: products,
                IncludeReservedOrders: false,
                IncludeShopReplenishments: false
            };
            service.call(requestData)
                .then(function (result) {
                resolve(result.response.Products);
            })
                .catch(reject);
        });
    }
    Availability.getStockAvailabilityEstimateForProducts = getStockAvailabilityEstimateForProducts;
    function getProductAvailabilty(products, options, organizationUnitID) {
        return new Promise(function (resolve, reject) {
            var service = new service_1.EVAService("GetProductAvailability");
            var requestData = {
                Products: products,
                Options: options,
                OrganizationUnitID: organizationUnitID
            };
            service.call(requestData)
                .then(function (result) {
                resolve(_.get(result, "response.Products") || []);
            })
                .catch(reject);
        });
    }
    Availability.getProductAvailabilty = getProductAvailabilty;
})(Availability = exports.Availability || (exports.Availability = {}));
